angular.module('impactx.util').directive('ixLimitFileSize', function (ToastService, TranslationService) {
    var MAXIMUM_FILE_SIZE_IN_MB = 4700;
    return {
        link: function (scope, element) {
            element.bind('change', function (event) {
                var fileSizeInBytes = event.currentTarget.files[0].size;
                var fileSizeInMegaBytes = Math.round(fileSizeInBytes / (1024 * 1024) * 100) / 100;

                if (fileSizeInMegaBytes > MAXIMUM_FILE_SIZE_IN_MB) {
                    element.val("");
                    ToastService.openStandardToast(TranslationService.get('maximumFileSizeError').replace('^0', MAXIMUM_FILE_SIZE_IN_MB));
                }
            });
        }
    }
});